import React from 'react';
// import logo from './images/mousco.svg';
import image from './images/Murwiza.svg';
import facebook from './images/facebook.svg';
import twitter from './images/twitter.svg';
import linkedin from './images/linkedin.svg';

const Mousco: React.FC = () => {
    return (
        <div className='text-white border-b-2 border-white md:border-none mb-6 pb-4'>
            <div className="mb-4">
                <img src={image} alt="" />
            </div>
            <div className='text-white'>
                <span>Book your next home, <br /> restaurant, car in Rwanda</span>
            </div>
            <div className='flex mt-4 w-1/2 justify-between'>
                <a href="#facebook"><img src={facebook} alt="" /></a>
                <a href="#twitter"><img src={twitter} alt="" /></a>
                <a href="#linkedin"><img src={linkedin} alt="" /></a>
            </div>
        </div>
    )
}

export default Mousco;